import {IController, IHttpResponse} from "angular";
import {OpportunitySetting} from "modules/user_settings/model/enums/enums";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";

import {PreviewResponse} from "modules/user_settings/model/PreviewResponse";
import {SmsSettings} from "modules/user_settings/model/UserSettings";

export class SmsRightSide implements IController {


    public selectedOpportunity: OpportunitySetting = OpportunitySetting.RATE_CALCULATOR;
    public opportunityList: Array<OpportunitySetting>;
    public smsPreviewData: string;
    public isLoading: boolean = false;
    public updatedSettings: SmsSettings;

    public static instance = {
        template: require('./right-side.html'),
        controller: [
            UserSettingsServiceName,
            SmsRightSide
        ],
        bindings: {
            updatedSettings: '<',
        },
    };

    constructor(
        private userSettingsService: UserSettingsService,
    ) {
    }

    $onInit() {

    }

    selectOpportunity(opportunity: OpportunitySetting) {
        this.selectedOpportunity = opportunity;
        console.log("Selected Opportunity:", this.selectedOpportunity);
    }

    renderSmsPreview() {
        const enumKeyFromValue = this.getEnumKeyFromValue(this.selectedOpportunity);
        this.isLoading = true;
        this.userSettingsService.renderSmsPreviewCall(this.updatedSettings, enumKeyFromValue,
            this.renderPreviewCallback, () => this.isLoading = false)
    }

    renderPreviewCallback = (response: IHttpResponse<PreviewResponse>) => {
        this.smsPreviewData = response.data.response.replace(/\n/g, '<br>')
    };


    handleOpportunitySelect = (opportunity: OpportunitySetting) => this.selectedOpportunity = opportunity;

    getEnumKeyFromValue = (value: string) => Object.keys(OpportunitySetting)
        .find(key => OpportunitySetting[key as keyof typeof OpportunitySetting] === value) || '';


}
